import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Account = {
  Profile: lazy(() => import('./containers/Profile/index.tsx')),
  Company: lazy(() => import('./containers/Company/index.tsx')),
  CompanyTab: lazyNamed(() => import('./containers/Company/tabs.ts'), 'CompanyTab'),
  CompanyUserGroupsList: lazyNamed(() => import('./containers/Company/tabs.ts'), 'UserGroupsList'),
  Users: lazyNamed(() => import('./containers/Users/index.tsx'), 'Users'),
  EditUser: lazyNamed(() => import('./containers/EditUser/index.tsx'), 'EditUser'),
  AdminAccessHistory: lazyNamed(() => import('./containers/AdminAccessHistory/index.tsx'), 'AdminAccessHistory'),
  AdminAccessHistoryRoute: lazyNamed(
    () => import('./containers/AdminAccessHistory/AdminAccessHistoryRoute.tsx'),
    'AdminAccessHistoryRoute',
  ),
};

export default Account;
